import React from "react";

/**
 * A reusable fixed footer component for pages
 * @param {React.ReactNode} children - Footer content
 * @param {string} className - Additional CSS classes
 */
export default function PageFooter({ children, className = "" }) {
  return (
    <footer className={`footer fixed-bottom bg-info ${className}`}>
      <div className="d-flex flex-row footer-btn-container align-items-center gap-3">
        {children}
      </div>
    </footer>
  );
}
